import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, switchMap } from 'rxjs';

import { GetEntityById2GQL } from 'generated/graphql';

import { NOTE_CHANGES } from './note.actions';

@Injectable()
export class NoteEffects {
  refetchEntityAfterNoteChanged$ = createEffect(
    () => this.actions$.pipe(
      ofType(NOTE_CHANGES),
      filter(({ payload }) =>
        payload?.targetType === 'Entity'
      ),
      switchMap(({ payload }) => this._getEntityByIdGQL.fetch(
        {
          entityId: payload.targetId,
          campaignId: payload.campaignId,
          withToplines: true
        },
        { fetchPolicy: 'network-only' })
      ),
    ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private _getEntityByIdGQL: GetEntityById2GQL,
  ) {
  }
}
